import type { Schemas } from '@shopware/api-client/api-types';

export const useCustomerStore = defineStore('customer', () => {
    const { refreshSessionContext, sessionContext } = useSessionContext();
    const { login, logout, register } = useUser();
    const { resetPassword } = useCustomerPassword();
    const { isRecoveryHashValid, recoverPassword } = usePasswordRecovery();
    const loading = ref(true);

    async function refreshContext() {
        loading.value = true;
        await refreshSessionContext();
        loading.value = false;
    }

    const customer = computed((): Schemas['Customer'] => sessionContext.value?.customer);
    const signedIn = computed(() => !!sessionContext.value?.customer);

    const setLoading = (state: boolean) => {
        loading.value = state;
    }

    return {
        refreshContext,
        customer,
        signedIn,
        setLoading,
        login,
        logout,
        loading,
        register,
        resetPassword,
        isRecoveryHashValid,
        recoverPassword,
    };
});
